export function formatTime(value) {
    if (typeof value !== "string") return value == null ? "" : String(value);

    const trimmed = value.trim();
    const match = trimmed.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
    if (!match) return trimmed;

    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const meridiem = match[3]?.toUpperCase();

    if (minutes > 59 || (meridiem ? hours < 1 || hours > 12 : hours > 23)) {
        return trimmed;
    }

    if (meridiem) {
        hours = (hours % 12) + (meridiem === "PM" ? 12 : 0);
    }

    const suffix = hours >= 12 ? "PM" : "AM";
    const displayHour = hours % 12 || 12;
    return `${displayHour}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

export function formatTimeRange(start, end) {
    if (!start) return "—";
    const formattedStart = formatTime(start);
    return end ? `${formattedStart} – ${formatTime(end)}` : formattedStart;
}
